import { render, staticRenderFns } from "./group-form.vue?vue&type=template&id=77d6b852&"
import script from "./group-form.vue?vue&type=script&lang=js&"
export * from "./group-form.vue?vue&type=script&lang=js&"
import style0 from "./group-form.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports